import * as SwitchPrimitive from '@radix-ui/react-switch';
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import { cn } from './cn';

export const Switch = forwardRef<
  ElementRef<typeof SwitchPrimitive.Root>,
  ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={cn(
      'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border',
      'transition-colors focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring-brand)]',
      'disabled:cursor-not-allowed disabled:opacity-50',
      // 켜짐=브랜드 액센트, 꺼짐=뚜렷한 중립 회색 트랙. 인라인 style 로 background 를
      // 고정하면 data-state 색상이 묻혀 토글해도 색이 안 변한다(활성여부가 사라진 것처럼 보임).
      // 이전엔 꺼짐 배경이 미정의 토큰(--surface-3)이라 투명으로 폴백 → 흰 카드 위에서
      // 트랙이 사라져 off 가 비활성처럼 보였다. 정의된 --content-soft(중간 회색)로 교체.
      'data-[state=checked]:bg-[var(--accent-default)] data-[state=unchecked]:bg-[var(--content-soft)]',
      // 켜짐/꺼짐 모두 테두리+미세 그림자로 트랙 경계를 또렷하게. 꺼짐=트랙보다 진한 무드
      // 테두리(--content-muted)+inset+outer 이중 그림자로 입체 대비를 강화, 켜짐=액센트 동색 테두리.
      'border-[var(--content-muted)] shadow-[var(--shadow-control-track)]',
      'data-[state=checked]:border-[var(--accent-default)] data-[state=checked]:shadow-[var(--shadow-control-track-active)]',
      className,
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb
      className={cn(
        'pointer-events-none block h-4 w-4 rounded-full bg-[var(--surface-0)] shadow-[var(--elevation-1)] ring-0',
        'transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0',
      )}
    />
  </SwitchPrimitive.Root>
));
Switch.displayName = SwitchPrimitive.Root.displayName;
